var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssue3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8398 53.3105H62.3017",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4766 56.498H67.3997",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 60.3223H65.4887L68.6756 63.5091",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8636 53.3105H18.4023",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2284 56.498H13.3047",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2261 60.3223H15.2148L12.0273 63.5091",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.307 51.7C23.6382 50.7562 23.9007 50.7625 24.0695 50.775L24.0632 51.0437C24.5132 50.6812 25.0632 50.2812 25.6257 50C26.0445 49.7937 28.9757 49.7187 32.7257 49.725C37.4445 49.725 43.4507 49.8375 47.3257 49.9187C49.5695 49.9625 51.0945 50 51.2507 50H54.6132C55.8132 50 56.8757 50 56.8757 50L57.0882 50.4312L57.2632 50.775C57.6132 50.7875 58.307 51.2437 59.1007 58.3437C59.5195 62.15 59.1195 68.9937 59.1007 69.2812C59.082 69.6125 58.807 69.8687 58.4757 69.8687H58.4382C58.157 69.85 57.9382 69.6437 57.8757 69.375H23.382C23.3257 69.6437 23.107 69.85 22.8195 69.8687H22.782C22.457 69.8687 22.182 69.6125 22.1632 69.2812C22.157 69.15 22.0632 67.6125 22.0132 65.625C21.9945 65.0625 21.982 64.4625 21.9757 63.8437C21.9507 61.9375 21.9882 59.8875 22.1632 58.3437C22.207 57.9812 22.2445 57.6375 22.2882 57.3062C22.3507 56.7437 22.4195 56.225 22.482 55.7562C22.682 54.3687 22.8695 53.3625 23.0382 52.6437C23.0695 52.525 23.1007 52.4125 23.1257 52.3062",
    fill: "#915524"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0992 69.2812C59.0805 69.6125 58.8055 69.8688 58.4742 69.8688H58.4367C58.1555 69.85 57.9367 69.6438 57.8742 69.375H23.3805C23.3242 69.6438 23.1055 69.85 22.818 69.8688H22.7805C22.4555 69.8688 22.1805 69.6125 22.1617 69.2812C22.1555 69.15 22.0617 67.6125 22.0117 65.625H52.1036C53.3573 65.625 54.3742 64.6087 54.3742 63.3544V50.625L54.6117 50C55.8117 50 56.8742 50 56.8742 50L57.0867 50.4313L57.2617 50.775C57.6117 50.7875 58.3055 51.2437 59.0992 58.3438C59.518 62.15 59.118 68.9938 59.0992 69.2812Z",
    fill: "#5E3312"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3266 49.9184L40.6266 61.2496C40.6266 61.2496 39.3766 58.7496 38.7516 57.4996C38.1266 56.2496 33.1266 50.6246 33.1266 50.6246L32.7266 49.7246C33.3641 49.7246 34.0266 49.7246 34.7078 49.7309C38.4266 49.7496 42.6078 49.8246 45.8391 49.8871C46.3641 49.8996 46.8578 49.9059 47.3266 49.9184Z",
    fill: "#004573"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3266 49.9184L40.6266 61.2496C40.6266 61.2496 39.3766 58.7496 38.7516 57.4996C38.1266 56.2496 33.1266 50.6246 33.1266 50.6246L32.7266 49.7246C33.3641 49.7246 34.0266 49.7246 34.7078 49.7309C35.7266 50.8059 37.3203 52.5371 38.1266 53.7496L39.9166 56.4346C40.2284 56.9027 40.9259 56.8715 41.1891 56.374C42.0078 54.8259 43.6691 51.9921 45.8391 49.8871C46.3641 49.8996 46.8578 49.9059 47.3266 49.9184Z",
    fill: "#03263A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7984 62.4296C39.7634 62.3946 41.4215 61.8821 40.6259 61.2496L30.6259 47.4996C30.8778 47.3684 30.4753 44.6259 30.4009 44.339C30.3146 44.004 29.974 43.8009 29.6396 43.8902C28.7134 44.1296 27.2484 44.7759 25.5296 46.4946C22.739 49.2852 23.4353 51.5027 23.4665 51.5959C23.5584 51.8727 23.8353 52.0459 24.1215 52.0202L28.944 51.5377L26.1346 54.8159C25.999 54.9734 25.9515 55.1884 26.0065 55.3884C26.0621 55.5884 26.2134 55.7484 26.4103 55.8152C26.429 55.8215 28.3434 56.4784 32.6734 58.9527C36.9915 61.4202 38.8971 63.2952 38.9159 63.3146C39.0378 63.4359 39.1971 63.4965 39.3571 63.4965C39.5171 63.4965 39.6778 63.4352 39.7996 63.3134C40.0421 63.0684 40.0421 62.6727 39.7984 62.4296Z",
    fill: "#B95A00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0273 45.8008C52.2548 43.7151 50.7198 44.3826 50.5536 44.4657C50.2542 44.6157 50.1386 44.9695 50.2761 45.2751C50.3273 45.3914 48.6498 49.3126 48.7517 49.3751L40.0136 62.6758C39.0323 63.5889 38.3773 64.2408 38.2848 64.3326C38.0405 64.577 38.0405 64.972 38.2848 65.2164C38.4067 65.3383 38.5667 65.3995 38.7267 65.3995C38.8867 65.3995 39.0467 65.3383 39.1686 65.2164C41.4311 62.9539 47.9561 56.9739 50.9361 56.4789C54.6236 55.8639 55.9161 55.8501 55.9267 55.8501C56.1792 55.8501 56.4073 55.6983 56.5042 55.4651C56.6005 55.2314 56.5473 54.9626 56.3692 54.7839C56.3692 54.7839 54.4623 52.8701 53.1867 51.5951L53.1723 51.5808L57.1323 52.0214C57.3092 52.0408 57.4855 51.9845 57.618 51.8658C57.7505 51.7476 57.8261 51.5776 57.8261 51.4001C57.8267 51.2576 57.7948 47.8764 55.0273 45.8008Z",
    fill: "#B95A00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1004 51.8188L24.1192 52.0188C23.8317 52.0438 23.5567 51.875 23.4629 51.5938C23.4379 51.5063 22.7379 49.2875 25.5317 46.4938C27.2504 44.775 28.7129 44.1313 29.6379 43.8938C29.9754 43.8 30.3129 44.0063 30.4004 44.3375C30.4129 44.3813 30.4254 44.4688 30.4504 44.6C29.7379 45.0063 28.9192 45.6063 28.0317 46.4938C25.2379 49.2875 25.9379 51.5063 25.9629 51.5938C25.9942 51.6813 26.0379 51.7563 26.1004 51.8188Z",
    fill: "#823B00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4375 49.4434C35.7687 53.3871 40.6313 60.9621 40.6313 60.9621",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8242 51.4004C57.8242 51.5754 57.7492 51.7504 57.618 51.8691C57.4805 51.9879 57.3055 52.0441 57.1305 52.0191L53.168 51.5816L53.1867 51.5941C54.4617 52.8691 56.368 54.7816 56.368 54.7816C56.543 54.9629 56.5992 55.2316 56.4992 55.4629C56.4055 55.7004 56.1742 55.8504 55.9242 55.8504C55.9117 55.8504 54.6242 55.8629 50.9367 56.4816C47.9555 56.9754 41.4305 62.9566 39.168 65.2191C39.043 65.3379 38.8867 65.4004 38.7242 65.4004C38.5617 65.4004 38.4055 65.3379 38.2805 65.2191C38.0367 64.9754 38.0367 64.5754 38.2805 64.3316C38.3742 64.2441 39.0305 63.5879 40.0117 62.6754L43.2992 57.6754C45.0305 56.4004 46.7342 55.6248 47.8117 55.2316C51.8742 53.7504 52.7867 54.6004 52.7992 54.6004C53.0492 54.6004 53.2805 54.4504 53.3742 54.2129C53.4742 53.9816 53.418 53.7129 53.243 53.5316C53.243 53.5316 52.5242 52.5254 51.2492 51.2504L54.0055 50.7691C54.1805 50.7941 54.3555 50.7379 54.493 50.6191C54.6242 50.5004 54.6992 50.3254 54.6992 50.1504C54.6992 50.0066 54.668 46.6254 51.8992 44.5504C51.7867 44.4629 51.6742 44.3816 51.5617 44.3066C52.318 44.3316 53.4742 44.6379 55.0242 45.8004C57.793 47.8754 57.8242 51.2566 57.8242 51.4004Z",
    fill: "#823B00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8009 62.4327C40.0447 62.6764 40.0447 63.0702 39.8009 63.3139C39.6759 63.4389 39.5134 63.4952 39.3572 63.4952C39.1947 63.4952 39.0384 63.4389 38.9134 63.3139C38.8947 63.2952 36.9884 61.4202 32.6697 58.9514C28.3447 56.4827 26.4259 55.8202 26.4072 55.8139C26.2134 55.7514 26.0634 55.5889 26.0072 55.3889C25.9509 55.1889 26.0009 54.9764 26.1322 54.8202L28.7134 51.8139L30.6478 51.6189C30.9359 51.5902 31.1122 51.927 30.9234 52.147L28.6322 54.8202C28.5009 54.9764 28.4509 55.1889 28.5072 55.3889C28.5634 55.5889 28.7134 55.7514 28.9072 55.8139C28.9259 55.8202 34.6047 55.2302 38.1259 58.7514C42.5009 63.1264 38.3759 61.7139 39.3759 62.5014C39.1759 62.5952 39.8009 62.4202 39.8009 62.4327Z",
    fill: "#823B00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0297 38.0254C59.6309 38.0254 58.4922 39.1629 58.4922 40.5623C58.4922 41.9616 59.6303 43.0998 61.0297 43.0998C62.4291 43.0998 63.5666 41.9616 63.5666 40.5623C63.5666 39.1629 62.4284 38.0254 61.0297 38.0254Z",
    fill: "#FFBD5B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5883 67.9578C71.9897 67.9578 73.1258 66.8217 73.1258 65.4203C73.1258 64.0189 71.9897 62.8828 70.5883 62.8828C69.1869 62.8828 68.0508 64.0189 68.0508 65.4203C68.0508 66.8217 69.1869 67.9578 70.5883 67.9578Z",
    fill: "#EE4C7B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1416 48.8509H19.6797V42.4766",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6781 38.0254C18.2794 38.0254 17.1406 39.1635 17.1406 40.5629C17.1406 41.9623 18.2788 43.0998 19.6781 43.0998C21.0775 43.0998 22.2156 41.9623 22.2156 40.5629C22.2156 39.1635 21.0775 38.0254 19.6781 38.0254Z",
    fill: "#00FF51"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 48.8509H61.0269V42.4766",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1189 62.8828C8.72016 62.8828 7.58203 64.0209 7.58203 65.4203C7.58203 66.8197 8.71953 67.9578 10.1189 67.9578C11.5177 67.9578 12.6564 66.8197 12.6564 65.4203C12.6564 64.0209 11.5183 62.8828 10.1189 62.8828Z",
    fill: "#006ED0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6009 28.6439C65.5159 28.6439 64.6328 27.7608 64.6328 26.6758C64.6328 26.3302 64.3534 26.0508 64.0078 26.0508C63.6622 26.0508 63.3828 26.3302 63.3828 26.6758C63.3828 27.7608 62.4997 28.6439 61.4141 28.6439C61.0684 28.6439 60.7891 28.9233 60.7891 29.2689C60.7891 29.6145 61.0684 29.8939 61.4141 29.8939C62.4997 29.8939 63.3828 30.777 63.3828 31.8627C63.3828 32.2083 63.6622 32.4877 64.0078 32.4877C64.3534 32.4877 64.6328 32.2083 64.6328 31.8627C64.6328 30.777 65.5159 29.8939 66.6009 29.8939C66.9466 29.8939 67.2259 29.6145 67.2259 29.2689C67.2259 28.9233 66.9466 28.6439 66.6009 28.6439Z",
    fill: "#00FF51"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 35.625C15.7557 35.625 16.875 34.5057 16.875 33.125C16.875 31.7443 15.7557 30.625 14.375 30.625C12.9943 30.625 11.875 31.7443 11.875 33.125C11.875 34.5057 12.9943 35.625 14.375 35.625Z",
    fill: "#EE4C7B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.149 47.8691C23.5678 49.9379 24.0553 51.4004 24.0553 51.4004L30.4303 50.7629L26.6053 55.2254C26.6053 55.2254 28.5178 55.8629 32.9803 58.4129C37.4428 60.9629 39.3553 62.8691 39.3553 62.8691M26.649 46.3066C28.0115 45.1191 29.1365 44.6691 29.7928 44.4941M39.999 63.7504C39.999 63.7504 40.6297 65.4223 41.904 65.4223C43.179 65.4223 44.4534 64.7848 44.4534 64.7848V69.2466",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1055 69.2468V62.873",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1562 69.2468V62.873",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0039 64.1465H50.1908",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 69.2461H64.852",
    stroke: "#4C2A13",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0291 42.4741C62.085 42.4741 62.9409 41.6182 62.9409 40.5623C62.9409 39.5064 62.085 38.6504 61.0291 38.6504C59.9732 38.6504 59.1172 39.5064 59.1172 40.5623C59.1172 41.6182 59.9732 42.4741 61.0291 42.4741Z",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5877 67.3335C71.6436 67.3335 72.4995 66.4775 72.4995 65.4216C72.4995 64.3657 71.6436 63.5098 70.5877 63.5098C69.5318 63.5098 68.6758 64.3657 68.6758 65.4216C68.6758 66.4775 69.5318 67.3335 70.5877 67.3335Z",
    stroke: "#8C0036",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6775 42.4741C20.7334 42.4741 21.5894 41.6182 21.5894 40.5623C21.5894 39.5064 20.7334 38.6504 19.6775 38.6504C18.6216 38.6504 17.7656 39.5064 17.7656 40.5623C17.7656 41.6182 18.6216 42.4741 19.6775 42.4741Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1189 67.3335C11.1748 67.3335 12.0308 66.4775 12.0308 65.4216C12.0308 64.3657 11.1748 63.5098 10.1189 63.5098C9.06301 63.5098 8.20703 64.3657 8.20703 65.4216C8.20703 66.4775 9.06301 67.3335 10.1189 67.3335Z",
    stroke: "#034677",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4628 30.7222C67.0463 29.1386 67.6791 27.2039 66.876 26.4009C66.073 25.5979 64.1383 26.2307 62.5548 27.8143C60.9712 29.3979 60.3385 31.3326 61.1415 32.1356C61.9445 32.9386 63.8792 32.3058 65.4628 30.7222Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7539 11.1504V14.3923",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3747 12.7715H22.1328",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 35C15.4105 35 16.25 34.1605 16.25 33.125C16.25 32.0895 15.4105 31.25 14.375 31.25C13.3395 31.25 12.5 32.0895 12.5 33.125C12.5 34.1605 13.3395 35 14.375 35Z",
    stroke: "#8C0036",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.34 14.6566C55.8169 14.6566 55.3906 14.2303 55.3906 13.7072C55.3906 13.1841 55.8169 12.7578 56.34 12.7578C56.8631 12.7578 57.2894 13.1841 57.2894 13.7072C57.2894 14.2303 56.8631 14.6566 56.34 14.6566Z",
    fill: "#EE4C7B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 10.625L35 13.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.625 10.625L46.125 13.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 9.5V5",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 13.7492V11.7617",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 20.625L60 18.125",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6273 19.375L63.8711 22.075",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3688 23.082L58.125 24.3758",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4688 20.625L23.3438 18.125",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 22.5L12.7188 19.375",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2172 24.3754L22.7109 23.3691",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.725 64.7758C38.8875 64.6133 42.2063 61.3196 45.5625 58.7821M38.725 64.7758C38.7187 64.7821 38.7188 64.7821 38.7188 64.7821M38.725 64.7758C38.7562 64.7133 39.0375 64.2258 41.2687 60.3258C43.5562 56.3196 47.9 50.2571 48.7625 49.0633M50.8313 45.0258C50.8313 45.0258 52.1063 44.3883 54.65 46.3008C57.2 48.2133 57.2 51.4008 57.2 51.4008L51.4687 50.7633C51.4687 50.7633 51.4687 50.7633 52.7437 52.0383C54.0187 53.3133 55.925 55.2258 55.925 55.2258C55.925 55.2258 54.65 55.2258 50.8313 55.8633C50.0063 56.0008 48.9687 56.4946 47.85 57.1883",
    stroke: "#331C0D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7406 32.2891C52.515 32.2891 52.3263 32.4147 52.2163 32.5941L50.6244 33.1247V36.2497L52.1806 35.7309C52.2813 35.9409 52.4919 36.0884 52.7406 36.0884C53.0863 36.0884 53.3656 35.8091 53.3656 35.4634V32.9141C53.3656 32.5684 53.0856 32.2891 52.7406 32.2891ZM28.0306 32.2891C28.2225 32.2891 28.3831 32.4147 28.4763 32.5941L29.83 33.1247V36.2497L28.5069 35.7309C28.4213 35.9409 28.2425 36.0884 28.0313 36.0884C27.7375 36.0884 27.5 35.8091 27.5 35.4634V32.9141C27.4994 32.5684 27.7369 32.2891 28.0306 32.2891Z",
    fill: "#004573"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8813 34.8398C26.2925 34.8398 25.3438 36.0261 25.3438 38.0142C25.3438 39.7605 28.0469 42.4636 29.7931 42.4636C30.1388 42.4636 30.4181 42.1842 30.4181 41.8386V38.0142C30.4188 36.0267 29.47 34.8398 27.8813 34.8398ZM52.74 34.8398C51.1513 34.8398 50.2025 36.0261 50.2025 38.0142V41.8386C50.2025 42.1842 50.4819 42.4636 50.8275 42.4636C52.5737 42.4636 55.2769 39.7605 55.2769 38.0142C55.2769 36.0267 54.3288 34.8398 52.74 34.8398Z",
    fill: "#E59991"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4594 31V44.8938C51.4594 48.125 48.8281 50.75 45.6031 50.75H35.0281C31.7969 50.75 29.1719 48.125 29.1719 44.8938V31C29.1719 30.6562 29.4531 30.375 29.7969 30.375H50.8344C51.1781 30.375 51.4594 30.6562 51.4594 31Z",
    fill: "#FFC7BE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4563 31V44.8938C51.4563 48.125 48.825 50.75 45.6 50.75L43.125 50.625C46.35 50.625 48.9563 48.125 48.9563 44.8938V31C48.9563 30.6562 48.675 30.375 48.3313 30.375H50.8313C51.175 30.375 51.4563 30.6562 51.4563 31Z",
    fill: "#E59991"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0056 35.5391H41.9062C41.5606 35.5391 41.2812 35.8184 41.2812 36.1641V39.0659C41.2812 40.3409 42.3188 41.3784 43.5944 41.3784H45.3181C46.5931 41.3784 47.6306 40.3409 47.6306 39.0659V36.1641C47.6306 35.8191 47.3513 35.5391 47.0056 35.5391Z",
    fill: "#4F2A0F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M47.632 36.1621V39.0684C47.632 40.3434 46.5945 41.3809 45.3195 41.3809H43.5945C43.5695 41.3809 43.5445 41.3809 43.5195 41.3746C44.757 41.3371 45.757 40.3184 45.757 39.0684V36.1621C45.757 35.8184 45.4758 35.5371 45.132 35.5371H47.007C47.3508 35.5371 47.632 35.8184 47.632 36.1621Z",
    fill: "#301808"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0039 38.0137L51.8745 34.375",
    stroke: "#4C2A13",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3475 38.0137L28.75 34.375",
    stroke: "#4C2A13",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 39.0684V38.109C43.3325 38.1177 43.3837 38.1246 43.4375 38.1246C43.955 38.1246 44.375 37.7046 44.375 37.1871C44.375 36.6696 43.955 36.2496 43.4375 36.2496C43.3837 36.2496 43.3325 36.2565 43.2812 36.2652V36.1621C43.2812 35.8184 43.5625 35.5371 43.9062 35.5371H41.9062C41.5625 35.5371 41.2812 35.8184 41.2812 36.1621V39.0684C41.2812 40.3434 42.3187 41.3809 43.5937 41.3809L45.625 41.2496C45.675 41.2496 45.575 40.6309 45.625 40.6246C44.4125 40.5559 43.2812 40.2996 43.2812 39.0684Z",
    fill: "#965123"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4464 35.5391H33.3477C33.002 35.5391 32.7227 35.8184 32.7227 36.1641V39.0659C32.7227 40.3409 33.7602 41.3784 35.0352 41.3784H36.7589C38.0339 41.3784 39.0714 40.3409 39.0714 39.0659V36.1641C39.0714 35.8191 38.7914 35.5391 38.4464 35.5391Z",
    fill: "#4F2A0F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.882 36.1621V39.0684C38.882 40.3434 37.8445 41.3809 36.5695 41.3809H34.8445C34.8195 41.3809 34.7945 41.3809 34.7695 41.3746C36.007 41.3371 37.007 40.3184 37.007 39.0684V36.1621C37.007 35.8184 36.7258 35.5371 36.382 35.5371H38.257C38.6008 35.5371 38.882 35.8184 38.882 36.1621Z",
    fill: "#301808"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5977 39.0666V38.1166C35.0095 38.1566 35.4133 37.9216 35.5652 37.5153C35.7464 37.0303 35.5008 36.4903 35.0158 36.3084C34.8777 36.2566 34.7352 36.2434 34.5977 36.2566V36.1641C34.5977 35.8184 34.877 35.5391 35.2227 35.5391H33.3477C33.002 35.5391 32.7227 35.8184 32.7227 36.1641V39.0659C32.7227 40.3409 33.7602 41.3784 35.0352 41.3784H36.7589C36.7845 41.3784 36.8089 41.3716 36.8345 41.3709C35.5958 41.3303 34.5977 40.3153 34.5977 39.0666Z",
    fill: "#965123"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0166 24.18C40.7691 24.1387 40.5922 24.1094 40.5047 24.0925C40.3828 24.0525 40.2397 24.0525 40.1178 24.0925C40.0297 24.1088 39.8534 24.1381 39.6059 24.18C25.8359 26.4987 24.0703 28.3862 24.0703 29.7712C24.0703 31.4469 25.7034 32.7369 28.9247 33.6069C31.7053 34.3575 35.5178 34.7544 39.9491 34.7544C47.9759 34.7544 56.5528 33.445 56.5528 29.7712C56.5516 28.3869 54.7859 26.4987 41.0166 24.18Z",
    fill: "#B95A00"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5492 29.7684C56.5492 33.4434 47.9742 34.7559 39.9492 34.7559C39.2992 34.7559 38.6617 34.7496 38.043 34.7309C45.4805 34.5434 52.793 33.1621 52.793 29.7684C52.793 28.4246 51.1305 26.6121 38.4367 24.3809C38.818 24.3121 39.2055 24.2496 39.6055 24.1809C39.8555 24.1371 40.0305 24.1121 40.118 24.0934C40.2367 24.0496 40.3805 24.0496 40.5055 24.0934C40.593 24.1121 40.768 24.1371 41.018 24.1809C54.7867 26.4996 56.5492 28.3871 56.5492 29.7684Z",
    fill: "#823B00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7188 38.0137H41.9056",
    stroke: "#4C2A13",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9922 41.2012V42.4755",
    stroke: "#E59991",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9937 45.0266C39.2925 45.0266 38.7188 44.4528 38.7188 43.7516C38.7188 43.0503 39.2925 42.4766 39.9937 42.4766",
    stroke: "#E59991",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3109 24.6937V24.6875M40.3109 24.6875C40.3047 24.6875 40.3047 24.6875 40.3047 24.6875M40.3109 24.6875C40.3172 24.6875 40.3172 24.6875 40.3172 24.6875",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7457 29.4891C48.802 30.0328 48.627 30.5828 48.2645 30.9891C47.8958 31.3953 47.3707 31.6266 46.827 31.6266H33.802C33.252 31.6266 32.7332 31.3953 32.3645 30.9891C32.002 30.5766 31.8207 30.0328 31.8832 29.4891L32.9832 19.3516C33.0895 18.3703 33.9145 17.6328 34.902 17.6328C34.977 17.6328 35.052 17.6453 35.1207 17.6703L35.2895 17.7328C35.2957 17.7328 35.2957 17.7328 35.302 17.7391C36.4145 18.1516 37.5707 18.4266 38.7395 18.5516C40.7645 18.7766 42.8333 18.5578 44.7895 17.9078L45.527 17.6641C45.5895 17.6391 45.6583 17.6328 45.727 17.6328C46.7145 17.6328 47.5395 18.3703 47.6458 19.3516L48.7457 29.4891Z",
    fill: "#915524"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7457 29.4891C48.802 30.0328 48.627 30.5828 48.2645 30.9891C47.8958 31.3953 47.3707 31.6266 46.827 31.6266H33.802C33.252 31.6266 32.7332 31.3953 32.3645 30.9891C32.002 30.5766 31.8207 30.0328 31.8832 29.4891L32.0332 28.1266H43.077C43.6207 28.1266 44.1458 27.8953 44.5145 27.4828C44.877 27.0766 45.052 26.5328 44.9957 25.9891L44.1395 18.1016C44.3583 18.0453 44.5708 17.9828 44.7895 17.9078L45.527 17.6641C45.5895 17.6391 45.6583 17.6328 45.727 17.6328C46.7145 17.6328 47.5395 18.3703 47.6458 19.3516L48.7457 29.4891Z",
    fill: "#5E3312"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8047 20.8027C36.8047 20.8027 38.0797 22.0777 41.2666 21.4402M43.1784 21.4402C43.1784 21.4402 44.4534 20.8027 45.0903 22.0777",
    stroke: "#B28C54",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue3);
export default __webpack_public_path__ + "static/media/issue-3.bfb36b4d91d469bff58abf680bbcb0b5.svg";
export { ForwardRef as ReactComponent };